import { ArticleParagraph3 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

interface IPromoEndProps {
  end: string;
}

export function PromoEnd({ end }: IPromoEndProps) {
  return (
    <div className={styles['container']}>
      <ArticleParagraph3 color="gray60_100">{end}</ArticleParagraph3>
    </div>
  );
}
